// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";
let commonUrl = "https://www.jprsxt.site/";//
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl